import type { DeviceTrackingData } from '$lib/utils/device.server';

class Device {
    #data = $state<DeviceTrackingData | null>(null);

    set data(data: DeviceTrackingData) {
        this.#data = data;
    }

    get data() {
        if (!this.#data) {
            throw new Error('Device data not set');
        }
        return this.#data;
    }
}

export const device = new Device();
